var jQuery = require('jquery');

/**
 * 3D Model for e-shop


 usage:

 <div id="model" data-model3d-directory="/01/touch/01" data-model3d-frames-count="60" >

 data-model3d-directory - expects path to directory and prefix of the file names without ordering number (e.g. products/1/1)
 - with this settings plugin expects files products/1/1_01.jpg, .. 1_02.jpg - 1_[frames.count].jpg

 $('#model').model3D({

});

 */

;(function($, window, document, undefined ) {
	"use strict";

	var PLUGIN_NAME = "model3D";
	var PLUGIN_VERSION = "v2.1";

	var	DEFAULTS = {
		width: 100,							// width of the 3D model
		height: 100,						// height of the 3D model
		controls: true,
		dragRotateCountPerDeviceWidth: {	// while drag'n'drop rotation - how many times should product rotate per device width
			desktop: 3,
			touch: 2
		},
		frameDuration: 92,					// frame duration in MS
		data: [],							// array of image paths
		dataDir: {
			path:	null,
			count: null
		}
	};

	/**
	 * set basic variables
	 * create options and settings for this instance
	 * @param element - DOM Element the plugin is applied to
	 * @param options - custom settings to be merged with DEFAULTS
	 * @constructor
	 */
	var Model3D = function ( element, options ) {
		this.element = element;
		this.$t = $(this.element);

		// internal data
		this.resourceData = null;
		this.resourceDirectory = null;
		this.resourceSourceUsed = null;
		this.framesCount = 0;

		this.manualRotation = null;

		this.animationInProgress = false;

		this.rotationDirection = 1;
		this.actualRotateFrame = 0;
		this.objectDragStart = -1;

		// timers
		this.rotateTimer = null;
		this.renewRotationTimer = null;

		// jquery DOM references
		this.$preloader = null;
		this.$preloaderText = null;
		this.$photoObject = null;
		this.$arrowPrev = null;
		this.$arrowNext = null;

		// merge options
		this.options = $.extend(true, {}, DEFAULTS, options );
		this._defaults = DEFAULTS;
		this.initialise();
	};

	/**
	 * init function
	 */
	Model3D.prototype.initialise = function() {
		var o = this.options;

		this.resourceSourceUsed = this.getResourcesInformation_();
		if (!this.resourceSourceUsed) {
			return false;
		}

		this.$t.css({
			height: o.height,
			width: o.width
		});

		this.preloadImages_();


		this.bindEvents();
		if (o.controls) {
			this.renderControls();
		}
		this.bindControls();
	};

	/**
	 * dataprovider - load path of image or directory with images
	 *
	 * data-model3d-sprite [DESKTOP] - expects path to sprite file within plugin storage (e.g. products/1/1-sprite.jpg)
	 * data-model3d-directory [MOBILE, DESKTOP FALLBACK] - expects path to directory and prefix of the file names without ordering number (e.g. products/1/1)
	 * 							- with this settings plugin expects files products/1/1_01.jpg, .. 1_02.jpg - 1_[frames.count].jpg
	 */
	Model3D.prototype.getResourcesInformation_ = function() {
		this.resourceData = this.options.data && $.isArray(this.options.data) && this.options.data.length > 0 ? this.options.data : null;
		this.resourceDirectory = this.$t.data('model3dDirectory') || this.options.dataDir.path;
		return this.resourceDirectory || this.resourceData;
	};

	/**
	 * rozhodnutí, zda se budou obrázky nahrávat z dat nebo z adresáře
	 * @private
	 */
	Model3D.prototype.preloadImages_ = function() {

		this.renderPreloader();
		this.$photoObject = $('<div style="position: relative;"></div>').appendTo(this.$t);

		if ($.isArray(this.resourceSourceUsed)) {
			// total count
			this.framesCount = this.options.data.length;

			// call recursive function
			this.preloadSingleImageFromData_(0, function() {
				this.removePreloader();
				this.$t.trigger('Model3D__RESOURCES_LOADED');
			});
		} else {

			// total count
			this.framesCount = this.options.dataDir.count || this.$t.data('framesCount');

			// call recursive function
			this.preloadSingleImageFromDirectory_(1, function() {
				this.removePreloader();
				this.$t.trigger('Model3D__RESOURCES_LOADED');
			});
		}
	};

	/**
	 * recursive function - load single images as long as there are any [frames.count]
	 */
	Model3D.prototype.preloadSingleImageFromDirectory_ = function(cnt, callback) {
		var o = this.options;
		var _self = this;
		var zero = (cnt<10) ? "0" : "";
		var path =	o.storage +
			this.resourceDirectory +
			'_' + zero + cnt + '.jpg';
		var $image = $('<img class="eshop-model3d__img" src="'+ path + '" style="display: none !important; position: absolute; top: 0; left: 0;">').appendTo(this.$photoObject);
		$image.on("load", function() {
			_self.$preloaderText.text(Math.round((100/_self.framesCount)*cnt)+' %');
			cnt++;
			if (cnt <= _self.framesCount) {
				_self.preloadSingleImageFromDirectory_(cnt, callback);
			} else {
				if ($.isFunction(callback)){
					$('img', _self.$photoObject).off();
					callback.call(_self);
				}
			}
		});
	};

	/**
	 * load single images from this.options.data
	 * @private
	 */
	Model3D.prototype.preloadSingleImageFromData_ = function(cnt, callback) {
		var o = this.options;
		var _self = this;
		var $image = $('<img class="eshop-model3d__img" src="'+ o.data[cnt] + '" style="display: none !important; position: absolute; top: 0; left: 0;">').appendTo(this.$photoObject);
		$image.on("load", function() {
			_self.$preloaderText.text(Math.round((100/_self.framesCount)*cnt)+' %');
			cnt++;
			if (cnt < _self.framesCount) {
				_self.preloadSingleImageFromData_(cnt, callback);
			} else {
				if ($.isFunction(callback)){
					$('img', _self.$photoObject).off();
					callback.call(_self);
				}
			}
		});
	};

	/**
	 * bind events
	 * Model3D__RESOURCES_LOADED - images are preloaded, start rendering and animate
	 */
	Model3D.prototype.bindEvents = function() {
		var o = this.options;
		var _self = this;
		this.$t.on('Model3D__RESOURCES_LOADED', function(e) {

			$('img', _self.$photoObject).show();
			_self.startAnimation();
		});
	};

	Model3D.prototype.renderControls = function() {
		this.$arrowPrev = $('<div class="eshop-model3d__arrow eshop-model3d__arrow--prev model3D__controls_arrow prev" data-direction="-1"><span class="eshop-model3d__ico ico"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#redo"></use></svg></span></div>').appendTo(this.$t);
		this.$arrowNext = $('<div class="eshop-model3d__arrow eshop-model3d__arrow--next model3D__controls_arrow next" data-direction="1"><span class="eshop-model3d__ico ico"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#undo"></use></svg></span></div>').appendTo(this.$t);
	};

	/**
	 * renders arrows and calls actions to bind on them
	 */
	Model3D.prototype.bindControls = function() {

		if (this.options.controls) {
			this.handleControlsArrows();
		}

		this.handleControlsDrag();
	};

	Model3D.prototype.handleControlsArrows = function() {

		var _self = this;
		var o = this.options;

		var startArrowRotate = function(ref, direction) {
			ref.stopAnimation();
			if (ref.rotationDirection == -1*direction) {
				ref.actualRotateFrame = ref.actualRotateFrame + 2*direction;
			}
			ref.rotationDirection = direction;
			ref.startAnimation();
			ref.manualRotation = true;
		};

		var stopArrowRotate = function(ref) {
			if (ref.manualRotation) {
				ref.stopAnimation();
				ref.manualRotation = false;
				ref.renewRotationTimer = setTimeout(function() { _self.startAnimation() }, 2000);
			}
		};

		// rotate left on mousedown - hold
		this.$arrowPrev.off('mousedown touchstart').on('mousedown touchstart', function(e) {
			e.preventDefault();
			e.stopPropagation();
			startArrowRotate(_self, 1);
		});

		// rotate right on mousedown - hold
		this.$arrowNext.off('mousedown touchstart').on('mousedown touchstart', function(e) {
			e.preventDefault();
			e.stopPropagation();
			startArrowRotate(_self, -1);
		});

		this.$arrowPrev.off('mouseup touchend').on('mouseup touchend', function(e) {
			e.preventDefault();
			e.stopPropagation();
			stopArrowRotate(_self);
		});

		this.$arrowNext.off('mouseup touchend').on('mouseup touchend', function(e) {
			e.preventDefault();
			e.stopPropagation();
			stopArrowRotate(_self);
		});
	};

	Model3D.prototype.handleControlsDrag = function() {
		var _self = this;
		var o = this.options;

		_self.rotateFrameStart = 0;
		_self.lastPosition = 0;

		// start drag
		this.$photoObject.off('mousedown').on('mousedown', function(e) {
			_self.handleDragStartEvent(e, 'mousedown');
		});
		this.$photoObject.off('touchstart').on('touchstart', function(e) {
			_self.handleDragStartEvent(e, 'touchstart');
		});

		// stop drag
		$(document).on('mouseup touchend', function() {
			if (_self.objectDragStart > -1) {
				_self.stopAnimation();
				_self.objectDragStart = -1;
				_self.renewRotationTimer = setTimeout(function() { _self.startAnimation() }, 2000);
			}
		});

		// mouse move
		$(document).on('mousemove', function(e) {
			_self.handleDragEvent(e, 'mousemove');
		});

		$(document).on('touchmove', function(e) {
			_self.handleDragEvent(e, 'touchmove');
		});

	};

	Model3D.prototype.handleDragStartEvent = function(e, event) {
		var _self = this;
		var o = this.options;

		e.preventDefault();
		_self.stopAnimation();
		_self.rotateFrameStart = _self.actualRotateFrame;
		_self.objectDragStart = event == 'mousedown' ? e.pageX : e.originalEvent.touches[0].pageX;
	};

	Model3D.prototype.handleDragEvent = function(e, event) {
		var _self = this;
		var o = this.options;
		var deviceType = event == 'mousemove' ? 'desktop' : 'touch';

		if (_self.objectDragStart < 0) { return true; } // drag has not started

		e.preventDefault();
		e.stopPropagation();
		_self.stopAnimation();

		var dragStep = Math.round($(window).width() / (_self.framesCount * o.dragRotateCountPerDeviceWidth[deviceType]));
		var pX = event == 'mousemove' ? e.pageX : e.originalEvent.touches[0].pageX;

		var diff = pX - _self.objectDragStart;

		if (diff < 0 && _self.rotationDirection == -1) {
			_self.actualRotateFrame = _self.actualRotateFrame + 2;
		}
		if (diff >= 0 && _self.rotationDirection == 1) {
			_self.actualRotateFrame = _self.actualRotateFrame - 2;
		}

		_self.rotationDirection = (pX < _self.lastPosition) ? 1 : -1;

		var frameDiff = Math.round(diff/dragStep);
		var resultFrame =(_self.rotateFrameStart - frameDiff) % _self.framesCount;
		if (resultFrame < 0) {
			resultFrame = _self.framesCount - Math.abs(resultFrame);
		}

		_self.lastPosition = pX;
		_self.moveToStep(resultFrame);

	};

	/**
	 * starts animation, clear proper timers
	 */
	Model3D.prototype.startAnimation = function() {
		var _self = this;
		clearTimeout(this.renewRotationTimer);
		this.animationInProgress = true;
		this.rotateTimer = setTimeout(function() { _self.rotateStep(_self.rotationDirection, true); }, _self.options.frameDuration);
	};


	/**
	 * stops animation
	 */
	Model3D.prototype.stopAnimation = function() {
		this.animationInProgress = false;
		clearTimeout(this.rotateTimer);
		clearTimeout(this.renewRotationTimer);
	};

	Model3D.prototype.rotateStep = function(direction, allowNext) {
		var o = this.options;
		var _self = this;
		clearTimeout(this.rotateTimer);

		// calculate frame
		this.actualRotateFrame = (this.actualRotateFrame > (this.framesCount - 1) ) ? 0 : this.actualRotateFrame;
		this.actualRotateFrame = (this.actualRotateFrame < 0 ) ? (this.framesCount - 1) : this.actualRotateFrame;

		$('img', this.$photoObject).css({
			'visibility' : 'hidden'
		});
		$('img:eq('+this.actualRotateFrame+')', this.$photoObject).css({
			'visibility' : 'visible'
		});

		this.actualRotateFrame += direction;

		if (allowNext) {
			this.rotateTimer = setTimeout(function() { _self.rotateStep(direction, true); }, _self.options.frameDuration);
		}

	};

	Model3D.prototype.moveToStep = function(step) {

		var o = this.options;
		var _self = this;

		clearTimeout(this.rotateTimer);
		this.actualRotateFrame = step;

		$('img', this.$photoObject).css({
			'visibility' : 'hidden'
		});
		$('img:eq('+this.actualRotateFrame+')', this.$photoObject).css({
			'visibility' : 'visible'
		});

		this.renewRotationTimer = setTimeout(function() { _self.startAnimation() }, 2000);
	};

	/**
	 * support function
	 */
	Model3D.prototype.renderPreloader = function() {
		this.$preloader = $('<div class="eshop-model3d__preloader-container model3D__preloader_container"></div>').appendTo(this.$t);
		$('<div class="eshop-model3d__preloader model3D__preloader"><div class="eshop-model3d__preloader-outer model3D__preloader_outer"></div><div class="eshop-model3d__preloader-inner model3D__preloader_inner"></div></div>').appendTo(this.$preloader);
		this.$preloaderText = $('<span style="display: block;"></span>').appendTo(this.$preloader);
	};

	Model3D.prototype.removePreloader = function() {
		this.$preloader.remove();
	};

	/**
	 * destructor
	 */

	Model3D.prototype.destroy = function() {
		if (this.$preloader instanceof $) {
			this.$preloader.remove();
		}
		if (this.$photoObject instanceof $) {
			this.$photoObject.off();
			this.$photoObject.remove();
		}
		if (this.$arrowPrev instanceof $) {
			this.$arrowPrev.off();
			this.$arrowPrev.remove();
		}
		if (this.$arrowNext instanceof $) {
			this.$arrowNext.off();
			this.$arrowNext.remove();
		}

		this.$t.off().css({
			width: 'auto',
			height: 'auto'
		});
		this.$t.removeData('plugin_' + PLUGIN_NAME);
		this.$t = null;
		this.element = null;
	};

	/**
	 * decide, which methods will be "public"
	 */
	var API = {
		destroy: Model3D.prototype.destroy
	};

	/**
	 * plugin go live
	 * @param value - first param - decides, which action shall be executed
	 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
	 * 		if string && in API object - run method named as this value with all args[index > 0]
	 * @return {*}
	 */
	$.fn[PLUGIN_NAME] = function (value) {
		var args = arguments;

		return this.each(function () {
			var $this = $(this);

			// get plugin instance
			var plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new Model3D(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);
			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
		});
	};


	/**
	 * setDefaults with $.googlemap.setDefaults();
	 */
	$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
	$[PLUGIN_NAME].setDefaults = function(newOptions) {
		DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
	};

	return Model3D;

})( jQuery, window, document );



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/jquery-model3D/jquery.model3D.js